module.exports = __webpack_public_path__ + "img/서브2_체력.40a15c43.svg";